import { React } from "react";

export default function ConfirmDialog({
  title = "",
  icon = null,
  isOpen = true,
  children,
  footer,
  footerStyle = {},
}) {
  return (
    <div id="custom-confirm-dialog">
      {isOpen && (
        <div className="custom-modal-overlay">
          <div className="custom-modal">
            {/* Header */}
            {title && (
              <div className="custom-modal-header">
                {icon && <div className="icon-wrapper">{icon}</div>}
                <h3>{title}</h3>
              </div>
            )}

            {/* Body */}

            <div className="custom-modal-body">{children}</div>

            {/* Footer */}
            <div className="custom-modal-footer" style={{ ...footerStyle }}>
              {footer}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
